// If restore in Freespin (Not on the first freespin), the Intro will do the restore work but not show.
// When restore on the first freespin (the round winning Freespin), show the Intro.

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {TimelineLite} from "gsap";
import {Tesla} from "../Tesla";
import {TeslaSoundConfig} from "../TeslaSoundConfig";
import {TeslaSymbolUtil} from "../utils/TeslaSymbolUtil";
import {TeslaFreeSpinIntroScreenView} from "./TeslaFreeSpinIntroScreenView";
import {TeslaFreeSpinOutroScreenView} from "./TeslaFreeSpinOutroScreenView";

export class TeslaFreeSpinOutroController extends FreespinOutroController {

    private _reelsEnteringFreespin:string[][] | undefined;
    private _totalWin:number;

    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super(config, tweakEnabled);
    }

    protected parseFeatureGameData(data:ParsedGameData):void {
        this._reelsEnteringFreespin = data.reelsEnteringFreespin;
        this._totalWin = data.totalWin;
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        let superValue = super.calculateIsTriggered(data);

        const wasFreespin:boolean = data.mode == GameMode.FREESPIN;
        const nextModeMainGame:boolean = data.nextMode == GameMode.NORMAL;
        const noFsLeft = (data.freespinsLeft == null || data.freespinsLeft <= 0);

        return wasFreespin && nextModeMainGame && noFsLeft;
    }

    // protected show():boolean {
    //     let timer:CountDownTimer = Tesla.freespinScreenAnimation.timer;
    //     (<TeslaFreeSpinOutroScreenView>this._view).setTimer(timer);
    //     (<TeslaFreeSpinOutroScreenView>this._view).setTimerCompleteCallback(() => this.finish());
    //
    //     return super.show();
    // }

    protected finish():void {
        if(this._reelsEnteringFreespin != undefined) {
            TeslaSymbolUtil.swapReels(this._reelsEnteringFreespin);
        }
        this.playSound();
        // (<TeslaFreeSpinOutroScreenView>this._view).setTimerCompleteCallback(() => {});
        (<TeslaFreeSpinIntroScreenView>this._view).hideButton();

        const tl:TimelineLite = new TimelineLite();

        tl.add((<TeslaFreeSpinOutroScreenView>this._view).getHideOutroAnimation());
        tl.add(Tesla.wildCollectIndicator.getOutro());
        tl.add(() => SlotGame.winFieldController.showWinField(this._totalWin));
        tl.add(Tesla.backgroundWindowAnimation.resetView());
        tl.add([
            () => Tesla.reelFrame.clearFreespinPostIntroAnimation(),
            () => Tesla.wildCollectRelease.removeAddedWildSymbols()
        ]);
        tl.add(() => super.finish());
    }

    private playSound():void {
        SlotGame.sound.playAmbience(TeslaSoundConfig.instance.MAIN_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(1.0, 0);
    }
}